<template>
  <div class="payment-request-modal--overlay">
    <div
      v-if="!showPaymentProofModal"
      class="payment-request-modal"
    >
      <button
        class="payment-request-modal__btn-close"
        @click="handleCloseModal"
      >
        <svg-loader src="/static/images/icon-close-small.svg" />
      </button>
      <div class="payment-request-modal__header">
        <h4>Solicitação de Crédito</h4>
        <h6>Confirme sua forma de pagamento e prossiga com o pagamento seguro.</h6>
      </div>
      <div
        v-if="isLoadingPayments"
        class="payment-history__loading"
      >
        <Spinner />
      </div>
      <div
        v-else
        class="payment-request-modal__content"
      >
        <div class="payment-request-modal__main">
          <div
            v-if="isPix"
            class="payment-details"
          >
            <div class="qr-code-wrapper">
              <img
                v-if="currentPayment.qrCodeUrl"
                :src="currentPayment.qrCodeUrl"
                alt="QR Code para pagamento PIX"
                class="qr-code"
              >
            </div>
            <div class="copy-code-container">
              <CopyInput :value="currentPayment.pixCode" />
            </div>
            <ul class="instructions">
              <li>Acesse o aplicativo do seu banco.</li>
              <li>Escolha pagar com Pix Copia e Cola.</li>
              <li>Copie e cole o código e confirme o pagamento.</li>
            </ul>
          </div>
          <div
            v-else-if="isBoleto"
            class="payment-details"
          >
            <p class="success-message">
              <svg-loader src="/static/images/exam-mask/check.svg" />
              Seu {{ currentPayment.paymentMethod.type.toLowerCase() }} foi gerado com sucesso!
            </p>
            <div class="barcode-wrapper">
              <img
                v-if="currentPayment.barCodeUrl"
                :src="currentPayment.barCodeUrl"
                alt="Código de barras do Boleto"
                class="barcode"
              >
            </div>
            <div class="copy-code-container copy-code-container--boleto">
              <button
                class="print-btn md-button btn btn-primary"
                @click="handlePrintBoleto"
              >
                <svg-loader src="/static/images/print-batch.svg" />
                Imprimir
              </button>
              <span>ou</span>
              <CopyInput :value="currentPayment.boletoCode" />
            </div>
            <ul class="instructions">
              <li>
                Você pode utilizar o leitor de código de barras<br>
                do aplicativo do seu banco ou copiar o código
              </li>
            </ul>
          </div>
          <div class="payment-details payment-details__qr-code">
            <div class="qr-code-wrapper">
              <img
                v-if="qrCodeUrl"
                :src="qrCodeUrl"
                alt="QR Code para pagamento PIX"
                class="qr-code"
              >
            </div>
            <div class="copy-code-container">
              <CopyInput :value="pixCode" />
            </div>
            <ul class="instructions">
              <li>Escolha pagar com Pix Copia e Cola.</li>
              <li>Copie e cole o código e confirme o pagamento.</li>
            </ul>
          </div>
        </div>
        <SummaryOrder :summary-data="summaryData" />
      </div>
      <div
        v-if="!isLoadingPayments"
        class="payment-request-modal__footer"
      >
        <template v-if="isPix">
          <p class="validity-info">
            <span class="icon-info">i</span>
            Este código tem validade de 2 horas.
          </p>
          <p class="confirmation-info">
            Assim que realizar o pagamento, o pedido será aprovado e você receberá um e-mail de confirmação.
          </p>
        </template>
        <template v-if="isBoleto">
          <p class="validity-info">
            <span class="icon-info">i</span>
            Este boleto tem validade de 5 dias.
          </p>
          <p class="confirmation-info">
            Assim que realizar o pagamento, o pedido será aprovado e você receberá um e-mail de confirmação.
          </p>
        </template>
      </div>
    </div>

    <PaymentProofModal
      v-if="showPaymentProofModal"
      :summary-data="currentPayment"
      :show-message-payment-confirmed="true"
      @close="handleCloseModalConfirmedPayment"
    />
  </div>
</template>

<script>
import notify from '@/api/notification'
import paymentsService from '@/api/payments'

import Spinner from '../../common/Spinner'
import SummaryOrder from './SummaryOrder'
import CopyInput from '../../common/CopyInput'
import billings from '../../../api/billings'
import PaymentProofModal from './PaymentProofModal'

export default {
  name: 'PaymentRequestModal',
  components: {
    Spinner,
    SummaryOrder,
    CopyInput,
    PaymentProofModal
  },
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bankPaymentCode: null,
      isLoadingPayments: true,
      loadedPayment: null,
      summaryData: null,
      intervalFetch: [],
      showPaymentProofModal: false,
      qrCodeUrl: null,
      pixCode: null
    }
  },
  computed: {
    currentPayment() {
      return this.loadedPayment || this.payment
    },
    isPix() {
      return this.currentPayment.paymentMethod.type.toLowerCase() === 'pix'
    },
    isBoleto() {
      return this.currentPayment.paymentMethod.type.toLowerCase() === 'boleto'
    },
    formattedValue() {
      return this.currentPayment.amount
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  mounted() {
    this.fetchPaymentDetails()
    this.startIntervals()
  },
  beforeDestroy() {
    this.stopIntervals()
  },
  methods: {
    startIntervals() {
      const totalDuration = 180000
      let elapsed = 0

      const executeRequest = () => {
        if (elapsed > totalDuration) return

        this.getDatilsPayment()
        elapsed += 20000

        const timeoutId = setTimeout(executeRequest, 20000)
        this.intervalFetch.push(timeoutId)
      }

      const firstTimeout = setTimeout(() => {
        elapsed += 60000
        executeRequest()
      }, 60000)

      this.intervalFetch?.push(firstTimeout)
    },
    stopIntervals() {
      console.log('stopIntervals', this.intervalFetch)
      if (this.intervalFetch.length === 0) return
      this.intervalFetch.forEach(clearInterval)
      this.intervalFetch = []
    },
    handleCloseModalConfirmedPayment() {
      this.showPaymentProofModal = false
      this.$emit('close')
    },
    getDatilsPayment() {
      paymentsService
        .getPaymentProof(this.currentPayment.paymentId)
        .then(res => {
          this.stopIntervals()

          this.showPaymentProofModal = true
        })
        .catch(err => {
          console.error('erro ao buscar dados de pagamento', err.response.data)
        })
    },
    handlePrintBoleto() {
      billings.getTicketData(this.bankPaymentCode, 'PREPAID').then(res => {
        const pagador = res.data.withdrawnCNPJ.replace(/\D/g, '')
        const beneficiario = res.data.assignorCNPJ.replace(/\D/g, '')
        const boleto = res.data.ticketNumberNotVerifyDigit
        const baseUrl = res.data.bankAddress.endsWith('/') ? res.data.bankAddress.slice(0, -1) : res.data.bankAddress

        window.open(
          `${baseUrl}/${boleto}/${pagador}/${beneficiario}/1`,
          '_blank'
        )
      })
    },
    fetchPaymentDetails() {
      this.isLoadingPayments = true
      const id = this.payment.paymentLink.split('/').pop()
      paymentsService
        .getPaymentById(id)
        .then(res => {
          this.pixCode = res.data.link
          this.qrCodeUrl = res.data.link
            ? `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(res.data.link)}`
            : ''

          if (this.payment.paymentMethod.type.toLowerCase() === 'boleto') {
            this.loadedPayment = {
              ...this.payment,
              barCodeUrl: res.data.numericBarCode
                ? `https://api-bwipjs.metafloor.com/?bcid=code128&text=${encodeURIComponent(res.data.numericBarCode)}`
                : '',
              boletoCode: res.data.typeableLine,
              chargeId: res.data.chargeId,
              txId: res.data.txId,
              status: res.data.status
            }
            this.bankPaymentCode = res.data.bankPaymentCode
          } else {
            this.loadedPayment = {
              ...this.payment,
              qrCodeUrl: res.data.link
                ? `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(res.data.link)}`
                : '',
              pixCode: res.data.code,
              chargeId: res.data.chargeId,
              txId: res.data.txId,
              status: res.data.status
            }
          }

          this.summaryData = {
            value: this.loadedPayment.amount,
            total: this.loadedPayment.amount,
            paymentMethod: this.loadedPayment.paymentMethod.type,
            txId: this.loadedPayment.txId
          }

          setTimeout(() => {
            this.isLoadingPayments = false
          }, 300)
        })
        .catch(error => {
          this.isLoadingPayments = false
          notify({
            title: 'ERRO:',
            message: 'Não foi possível carregar os detalhes do pagamento!'
          })
          console.error('Erro ao carregar os detalhes do pagamento:', error)
        })
    },
    copyPixCode() {
      navigator.clipboard.writeText(this.currentPayment.pixCode)
      notify({
        title: '',
        message: 'Código PIX copiado!'
      })
    },
    copyBoletoCode() {
      navigator.clipboard.writeText(this.currentPayment.boletoCode)
      notify({
        title: '',
        message: 'Código do Boleto copiado!'
      })
    },
    handleCloseModal() {
      this.stopIntervals()
      this.getDatilsPayment()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .payment-request-modal--overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .payment-request-modal {
    background-color: #ffffff;
    padding: 48px 80px;
    border-radius: 10px;
    width: 1100px;
    max-width: 95%;
    max-height: 97%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    position: relative;
    color: #595959;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: #7f1a54;
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #7f1a54;
        background: transparent;
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #7f1a54;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #7f1a54;
    }

    &__btn-close {
      background: none;
      position: absolute;
      right: 15px;
      top: 15px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    &__header {
      margin-bottom: 16px;
      h4 {
        font-size: 18px;
        margin-bottom: 4px;
      }
      h6 {
        font-size: 14px;
        font-weight: 400;
        color: #777;
      }
    }

    &__content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 50px;
    }

    &__main {
      flex: 1;
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 50px;
      width: 100%;

      .success-message {
        color: #161616;
        font-weight: bold;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .md-icon {
          margin: 0;
        }
      }

      .success-description {
        font-size: 14px;
        text-align: center;
      }
    }

    &__footer {
      margin-top: 40px;
      .validity-info {
        .icon-info {
          display: inline-flex;
          width: 20px;
          height: 20px;
          background-color: #7f1a54;
          color: #fff;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          font-weight: bolder;
          margin-right: 8px;
        }
      }
      .confirmation-info {
        margin-top: 16px;
      }
    }
  }

  .payment-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 0 0;
    .qr-code-wrapper,
    .barcode-wrapper {
      text-align: center;
      margin-bottom: 16px;
      width: 90%;
      img.qr-code,
      img.barcode {
        margin: 25px 0;
      }
      img.qr-code {
        width: 150px;
      }
      img.barcode {
        max-height: 92px;
      }
    }
    .qr-code-wrapper{
      margin-bottom:0;
    }
    .copy-code-container {
      width: 100%;
      max-width: 363px;
      &--boleto {
        display: flex;
        gap: 15px;
        align-items: center;
        justify-content: center;
        max-width: 540px;
        .copy-input {
          flex: 1;
        }

        .print-btn {
          display: block;
          margin: 0 auto !important;

          .md-icon {
            margin-right: 4px;
          }

          path {
            fill: #ffffff !important;
          }
        }
      }
    }
    .instructions {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 16px;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        color: #4a4a4a;

        &::before {
          content: '';
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #76d692;
          margin-right: 8px;
        }
      }
    }
  }
</style>
